/**
 * Multi-Variant Cart Controller v5
 * - Selections persist after adding to cart (no reset)
 * - Clear visual feedback: button shows "Agregado" state
 * - "Comprar ahora" always clears cart first, adds current selection, redirects
 * - Original buy buttons ALWAYS hidden (replaced by our UI)
 * - No desync between UI and cart
 */
(function () {
  'use strict';

  var DEBUG = true;

  function log() {
    if (DEBUG) console.log.apply(console, ['[MultiVariantCart]'].concat(Array.from(arguments)));
  }

  function tryInit() {
    var el = document.querySelector('multi-variant-cart');
    if (!el) {
      var obs = new MutationObserver(function () {
        var found = document.querySelector('multi-variant-cart');
        if (found) { obs.disconnect(); initController(found); }
      });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        var found = document.querySelector('multi-variant-cart');
        if (found) { obs.disconnect(); initController(found); }
      }, 3000);
      return;
    }
    initController(el);
  }

  function initController(el) {
    log('Initializing...');

    // ---- STATE ----
    var variants = [];
    var optionsMeta = {};
    var selectedOrigins = {};
    var quantities = {};
    var selectedGrams = null;
    var toastTimeout = null;
    var isSubmitting = false;

    // ---- PARSE DATA ----
    try {
      var vJson = el.querySelector('[data-variants-json]');
      variants = vJson ? JSON.parse(vJson.textContent) : [];
      log('Loaded', variants.length, 'variants');
    } catch (e) { log('ERROR parsing variants:', e); }

    try {
      var oJson = el.querySelector('[data-options-json]');
      optionsMeta = oJson ? JSON.parse(oJson.textContent) : {};
    } catch (e) { log('ERROR parsing options:', e); }

    // ---- DOM REFS ----
    var originsList = el.querySelector('[data-origins-list]');
    var summary = el.querySelector('[data-summary]');
    var summaryText = el.querySelector('[data-summary-text]');
    var summaryTotal = el.querySelector('[data-summary-total]');
    var buttons = el.querySelector('[data-buttons]');
    var addToCartBtn = el.querySelector('[data-multi-add-to-cart]');
    var buyNowBtn = el.querySelector('[data-multi-buy-now]');
    var clearAllBtn = el.querySelector('[data-clear-all]');
    var multiCountEl = document.querySelector('[data-multi-count]');
    var multiCountNumber = document.querySelector('[data-multi-count-number]');
    var variantPicker = document.querySelector('variant-picker');
    var buyButtonsBlock = document.querySelector('product-form-component');

    // Show our multi-variant section
    el.style.display = 'block';

    // ---- HELPERS ----

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function formatMoney(cents) {
      var fmt = (optionsMeta.currency || '${{amount}}');
      if (fmt.indexOf('amount_no_decimals') !== -1) {
        return '$' + Math.round(cents / 100).toLocaleString('es-CL');
      }
      if (fmt.indexOf('amount_with_comma_separator') !== -1) {
        return '$' + parseInt((cents / 100).toFixed(0)).toLocaleString('es-CL');
      }
      var amount = cents / 100;
      if (amount === Math.floor(amount)) {
        return '$' + amount.toLocaleString('es-CL');
      }
      return '$' + amount.toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }

    function getSelectedOriginsArray() {
      return Object.keys(selectedOrigins);
    }

    function findVariant(originValue, gramsValue) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options[0] === originValue && v.options[1] === gramsValue) {
          return v;
        }
      }
      return null;
    }

    // ---- UI UPDATES ----

    function createOriginRow(origin, qty, linePrice, variant) {
      var row = document.createElement('div');
      row.className = 'multi-variant-cart__origin-row';
      row.dataset.origin = origin;

      // Build thumbnail HTML
      var thumbHTML = '';
      var imgUrl = variant && variant.image ? variant.image : null;
      if (imgUrl) {
        thumbHTML = '<div class="multi-variant-cart__origin-thumb"><img src="' + imgUrl + '" alt="' + escapeHtml(origin) + '" loading="lazy"></div>';
      }

      row.innerHTML =
        '<button type="button" class="multi-variant-cart__origin-remove" data-remove-origin title="Quitar">&times;</button>' +
        thumbHTML +
        '<div class="multi-variant-cart__origin-info">' +
          '<span class="multi-variant-cart__origin-name">' + escapeHtml(origin) + '</span>' +
          '<span class="multi-variant-cart__origin-price" data-origin-price>' + formatMoney(linePrice) + '</span>' +
        '</div>' +
        '<div class="multi-variant-cart__qty-stepper">' +
          '<button type="button" class="multi-variant-cart__qty-btn" data-qty-minus ' + (qty <= 1 ? 'disabled' : '') + '>\u2212</button>' +
          '<span class="multi-variant-cart__qty-value" data-qty-value>' + qty + '</span>' +
          '<button type="button" class="multi-variant-cart__qty-btn" data-qty-plus>+</button>' +
        '</div>';

      row.querySelector('[data-remove-origin]').addEventListener('click', function () {
        // Remove from state
        delete selectedOrigins[origin];
        delete quantities[origin];
        // Uncheck the corresponding checkbox
        var cbs = document.querySelectorAll('.multi-origin-checkbox');
        for (var c = 0; c < cbs.length; c++) {
          if (cbs[c].value === origin) {
            cbs[c].checked = false;
            var label = cbs[c].closest('.variant-option__button-label--multi');
            if (label) label.classList.remove('is-checked');
            break;
          }
        }
        updateUI();
      });

      row.querySelector('[data-qty-minus]').addEventListener('click', function () {
        quantities[origin] = Math.max(1, (quantities[origin] || 1) - 1);
        updateUI();
      });

      row.querySelector('[data-qty-plus]').addEventListener('click', function () {
        quantities[origin] = Math.min(99, (quantities[origin] || 1) + 1);
        updateUI();
      });

      return row;
    }

    function renderOriginRows() {
      if (!originsList) return;

      var origins = getSelectedOriginsArray();
      var existingRows = originsList.querySelectorAll('.multi-variant-cart__origin-row');
      var existingMap = {};

      for (var i = 0; i < existingRows.length; i++) {
        existingMap[existingRows[i].dataset.origin] = existingRows[i];
      }

      for (var j = 0; j < existingRows.length; j++) {
        if (!selectedOrigins[existingRows[j].dataset.origin]) {
          existingRows[j].remove();
        }
      }

      for (var k = 0; k < origins.length; k++) {
        var origin = origins[k];
        var qty = quantities[origin] || 1;
        var variant = findVariant(origin, selectedGrams);
        var price = variant ? variant.price : 0;
        var linePrice = price * qty;

        if (existingMap[origin]) {
          var row = existingMap[origin];
          var priceEl = row.querySelector('[data-origin-price]');
          var qtyEl = row.querySelector('[data-qty-value]');
          var minusBtn = row.querySelector('[data-qty-minus]');
          if (priceEl) priceEl.textContent = formatMoney(linePrice);
          if (qtyEl) qtyEl.textContent = qty;
          if (minusBtn) minusBtn.disabled = qty <= 1;
        } else {
          originsList.appendChild(createOriginRow(origin, qty, linePrice, variant));
        }
      }
    }

    function updateSummary() {
      var origins = getSelectedOriginsArray();
      var totalBags = 0;
      var totalPrice = 0;
      var allAvailable = true;

      for (var i = 0; i < origins.length; i++) {
        var qty = quantities[origins[i]] || 1;
        var variant = findVariant(origins[i], selectedGrams);
        if (variant) {
          totalBags += qty;
          totalPrice += variant.price * qty;
          if (!variant.available) allAvailable = false;
        } else {
          allAvailable = false;
        }
      }

      var hasItems = totalBags > 0;
      if (summary) summary.style.display = hasItems ? 'block' : 'none';
      if (buttons) buttons.style.display = hasItems ? 'flex' : 'none';

      if (summaryText) {
        var gl = selectedGrams ? selectedGrams + 'g c/u' : '';
        summaryText.textContent = totalBags + ' bolsa' + (totalBags > 1 ? 's' : '') + ' \u00B7 ' + gl;
      }
      if (summaryTotal) summaryTotal.textContent = formatMoney(totalPrice);

      if (addToCartBtn) addToCartBtn.disabled = !allAvailable || isSubmitting;
      if (buyNowBtn) buyNowBtn.disabled = !allAvailable || isSubmitting;
    }

    function updateUI() {
      var origins = getSelectedOriginsArray();
      var hasSelections = origins.length > 0;
      log('updateUI - origins:', origins, 'grams:', selectedGrams);

      // Multi-variant section: show quantity rows only when selections exist
      el.style.display = 'block';

      // Update origin count badge
      if (multiCountEl) multiCountEl.style.display = hasSelections ? 'inline' : 'none';
      if (multiCountNumber) multiCountNumber.textContent = origins.length;

      // Show/hide the divider and header only when there are selections
      var divider = el.querySelector('.multi-variant-cart__divider');
      var header = el.querySelector('.multi-variant-cart__header');
      if (divider) divider.style.display = hasSelections ? 'block' : 'none';
      if (header) header.style.display = hasSelections ? 'flex' : 'none';

      // Toggle original buy buttons: show when NO selections, hide when multi-select active
      if (buyButtonsBlock) {
        var fb = buyButtonsBlock.querySelector('.product-form-buttons');
        if (fb) fb.style.display = hasSelections ? 'none' : '';
      }
      var stickyBar = document.querySelector('sticky-add-to-cart');
      if (stickyBar) stickyBar.style.display = hasSelections ? 'none' : '';

      renderOriginRows();
      updateSummary();
    }

    // ---- CART API ----

    /**
     * After adding to cart, fetch the updated cart with section rendering,
     * dispatch the theme's CartAddEvent (which is 'cart:update'),
     * and open the cart drawer.
     */
    function refreshAndOpenDrawer(cartResult) {
      // Fetch cart with sections that the theme needs to update
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          log('Cart fetched:', cart.item_count, 'items');

          // Dispatch the theme's cart:update event with the correct structure
          // This is what CartAddEvent uses: new Event('cart:update', { bubbles: true })
          // with detail: { resource, sourceId, data: { sections, itemCount } }
          try {
            var evt = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'multi-variant-cart',
                data: {
                  source: 'multi-variant-cart',
                  itemCount: cart.item_count
                }
              }
            });
            document.dispatchEvent(evt);
            log('Dispatched cart:update event');
          } catch (e) {
            log('Error dispatching cart:update:', e);
          }

          // Open the cart drawer directly
          try {
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.showDialog === 'function') {
              // Small delay to let the theme process the cart:update event first
              setTimeout(function () {
                drawer.showDialog();
                log('Cart drawer opened');
              }, 300);
            } else if (drawer && typeof drawer.open === 'function') {
              setTimeout(function () {
                drawer.open();
                log('Cart drawer opened via open()');
              }, 300);
            } else {
              log('Cart drawer not found or no showDialog method');
            }
          } catch (e) {
            log('Error opening cart drawer:', e);
          }
        })
        .catch(function (e) {
          log('Error fetching cart:', e);
        });
    }

    function addAllToCart(goToCheckout) {
      if (isSubmitting) return;

      var origins = getSelectedOriginsArray();
      var items = [];

      for (var i = 0; i < origins.length; i++) {
        var qty = quantities[origins[i]] || 1;
        var variant = findVariant(origins[i], selectedGrams);
        if (variant && variant.available) {
          items.push({ id: variant.id, quantity: qty });
        }
      }

      if (items.length === 0) return;

      isSubmitting = true;
      log(goToCheckout ? 'Buy now:' : 'Add to cart:', JSON.stringify(items));

      // Visual feedback on buttons
      var addBtnOriginalHTML = addToCartBtn ? addToCartBtn.innerHTML : '';
      if (addToCartBtn) { addToCartBtn.disabled = true; }
      if (buyNowBtn) {
        buyNowBtn.disabled = true;
        if (goToCheckout) buyNowBtn.textContent = 'Procesando...';
      }

      // "Comprar ahora" always clears cart first
      var cartPromise;
      if (goToCheckout) {
        cartPromise = fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
      } else {
        cartPromise = Promise.resolve();
      }

      cartPromise
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Error al agregar al carrito');
          });
        }
        return response.json();
      })
      .then(function (result) {
        log('Cart response:', result);
        var totalBags = 0;
        for (var j = 0; j < items.length; j++) totalBags += items[j].quantity;

        if (goToCheckout) {
          window.location.href = '/checkout';
          return;
        }

        // === SUCCESS: "Agregar al carrito" ===
        // DO NOT reset selections — keep them visible so user sees what they added

        // Show success state on button for 3 seconds
        if (addToCartBtn) {
          addToCartBtn.innerHTML =
            '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">' +
            '<path d="M20 6L9 17l-5-5"/>' +
            '</svg> \u00A1Agregado al carrito!';
          addToCartBtn.classList.add('multi-variant-cart__add-btn--success');

          setTimeout(function () {
            addToCartBtn.innerHTML = addBtnOriginalHTML;
            addToCartBtn.classList.remove('multi-variant-cart__add-btn--success');
          }, 3000);
        }

        // Show toast
        showToast(totalBags + ' bolsa' + (totalBags > 1 ? 's' : '') + ' agregada' + (totalBags > 1 ? 's' : '') + ' al carrito');

        // Refresh cart UI and open drawer
        refreshAndOpenDrawer(result);
      })
      .catch(function (err) {
        console.error('Multi-variant cart error:', err);
        showToast('Error: ' + err.message);
      })
      .finally(function () {
        isSubmitting = false;
        if (addToCartBtn) addToCartBtn.disabled = false;
        if (buyNowBtn) {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = 'Comprar ahora';
        }
      });
    }

    function clearAll() {
      selectedOrigins = {};
      quantities = {};
      var cbs = document.querySelectorAll('.multi-origin-checkbox');
      for (var i = 0; i < cbs.length; i++) {
        cbs[i].checked = false;
        var label = cbs[i].closest('.variant-option__button-label--multi');
        if (label) label.classList.remove('is-checked');
      }
      updateUI();
    }

    // ---- TOAST ----

    var toastEl = document.createElement('div');
    toastEl.className = 'multi-variant-cart__toast';
    toastEl.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7ec69a" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>' +
      '<span data-toast-text></span>';
    document.body.appendChild(toastEl);

    function showToast(message) {
      var txt = toastEl.querySelector('[data-toast-text]');
      if (txt) txt.textContent = message;
      toastEl.classList.add('multi-variant-cart__toast--visible');
      clearTimeout(toastTimeout);
      toastTimeout = setTimeout(function () {
        toastEl.classList.remove('multi-variant-cart__toast--visible');
      }, 3000);
    }

    // ---- BIND EVENTS ----

    // Origin checkboxes
    var checkboxes = document.querySelectorAll('.multi-origin-checkbox');
    log('Found', checkboxes.length, 'origin checkboxes');

    for (var i = 0; i < checkboxes.length; i++) {
      (function (cb) {
        cb.addEventListener('change', function () {
          var origin = cb.value;
          var label = cb.closest('.variant-option__button-label--multi');
          log('Checkbox:', origin, cb.checked);
          if (cb.checked) {
            selectedOrigins[origin] = true;
            if (!quantities[origin]) quantities[origin] = 1;
            if (label) label.classList.add('is-checked');
          } else {
            delete selectedOrigins[origin];
            delete quantities[origin];
            if (label) label.classList.remove('is-checked');
          }
          updateUI();
        });
      })(checkboxes[i]);
    }

    // Grams radios
    if (variantPicker) {
      var gramsFieldsets = variantPicker.querySelectorAll('fieldset:not([data-multi-select])');
      for (var g = 0; g < gramsFieldsets.length; g++) {
        var radios = gramsFieldsets[g].querySelectorAll('input[type="radio"]');
        for (var r = 0; r < radios.length; r++) {
          (function (radio) {
            radio.addEventListener('change', function () {
              selectedGrams = radio.value;
              updateUI();
            });
          })(radios[r]);
        }
      }

      var checkedRadio = variantPicker.querySelector('fieldset:not([data-multi-select]) input[type="radio"]:checked');
      if (checkedRadio) {
        selectedGrams = checkedRadio.value;
        log('Initial grams:', selectedGrams);
      }

      var gramsSelects = variantPicker.querySelectorAll('.variant-option--dropdowns select');
      for (var s = 0; s < gramsSelects.length; s++) {
        (function (sel) {
          sel.addEventListener('change', function () {
            selectedGrams = sel.value;
            updateUI();
          });
          if (!selectedGrams && sel.selectedIndex >= 0) {
            selectedGrams = sel.options[sel.selectedIndex].value;
          }
        })(gramsSelects[s]);
      }
    }

    // Buttons
    if (addToCartBtn) addToCartBtn.addEventListener('click', function () { addAllToCart(false); });
    if (buyNowBtn) buyNowBtn.addEventListener('click', function () { addAllToCart(true); });
    if (clearAllBtn) clearAllBtn.addEventListener('click', clearAll);

    // Initial UI render
    updateUI();

    log('Setup complete!');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();